module.exports = "<button type={{buttonParams.type}} class=\"{{buttonParams.class}}\" id=\"{{buttonParams.id}}\">{{buttonParams.label}} </button>"